import ListOut from '@components/shared/ListOut'
import useGradualFetch from '@hooks/useGradualFetch'
import Empty from '@components/shared/Empty'
import Icon from '@components/shared/Icon'
import userName from '@utils/user/userName'
import salonLogo from '@utils/links/salonLogo'
import useT from '@hooks/useTranslation'

import { apiFetcherProtected } from '@api/apiFetcher'

import styles from '@components/chat/styles/Contacts.module.css'

const PER_PAGE = 20
const API = '/api/chat/contacts/:skip/:limit'

// TODO: cache contacts, invalidate on new message event
const Contacts = ({ isOpen, user, highlightContact, currentContact }) => {
    const [contacts, loading, button] = useGradualFetch(API,
        apiFetcherProtected(user?.token), PER_PAGE)

    const text = useT('Nikogo tu nie ma. Nawiązuj kontakty handlowe odpowiadając na oferty')

    if (contacts.length < 1 && loading || !isOpen) return null

    return <div className={styles.list}>
        { contacts.length > 0
            ? <><ListOut id="_id" items={contacts} Component={Contact}
                    highlightContact={highlightContact} currentContact={currentContact} />

                {button}
              </>

            : <Empty text={<><Icon>contacts</Icon> {text}.</>} /> }
    </div>
}

function Contact (props) {
    const { _id, highlightContact, currentContact, ...contact } = props

    const isActive = currentContact === _id
    const name = userName(contact)

    const wrapperProps = isActive
        ? {
            className: styles.active,
            onClick: () => highlightContact(null),
          }
        : {
            className: styles.inactive,
            onClick: () => highlightContact(_id),
          }

    return (
        <div {...wrapperProps}>
            <Avatar name={name} id={contact.has_logo && _id} />
            <span>{name}</span>
            {/* TODO: block/unblock */}
            {/* TODO: Flag user */}
        </div>
    )
}

function Avatar ({ name, id }) {
    return <div className={styles.avatar}>
        { id
            ? <img src={salonLogo(id)} alt={name} />
            : <span>{name[0]}</span> }
    </div>
}

export default Contacts